export default "/* virtual:windi.css(boot) */";